<template>
  <div id="mod2">
    <PopupModal ref="mod2CustomerProfile" :P_largeModal="true" :P_showClose="true" @close-modal="closeSelf">
    
      <!-- Title -->
      <div slot="title"> 
        <h3  class="font-bold"></h3>
      </div>

      <!-- Body -->
      <template slot="body">
        <div class="pb-10">
          <c2CustomerProfile
            v-if="DV_showModal"
            :P_consumerUid="P_consumerUid"
            @event-back="closeSelf"
            :P_isModal="true"
            :P_viewType="P_viewType"
          ></c2CustomerProfile>
        </div>
      </template>
    </PopupModal>
  </div>
</template>

<script>
import moment from 'moment';
import PopupModal from './PopupModal.vue';
import c2CustomerProfile from "../c1/c2CustomerProfile.vue"

export default {
  name: "mod2CustomerProfile",

  props: ['P_consumerUid', 'P_viewType'],

  components: {PopupModal, c2CustomerProfile },

  data() {
    return {
      DV_ccIndexes: window.G_bi2_data.IV_al_consumer_contact_index,
      DV_consumerContact: null,
      DV_conversationInfo: null,
      DV_consumerConversationUuid: "",
      moment: moment,
      DV_showModal: false,
    };
  },

  mounted() {
    // 
  },
  watch: {
    // 
  },

  methods: {
    showSelf() {
      this.DV_showModal = true;
      this.$refs.mod2CustomerProfile.show();        
    },
    
    closeSelf() {
      this.$refs.mod2CustomerProfile.hide();
      this.DV_showModal = false;
    },    
  },
};
</script>

